import React from 'react';

const renderElement = (translation, index, tagName = 'p') =>
  React.createElement(tagName, { key: index, dangerouslySetInnerHTML: { __html: translation } });

export const renderWithBreaks = (text, tagName = 'p') =>
  text.split('<br>').map((translation, index) => renderElement(translation, index, tagName));

export const renderQAWithBreaks = text =>
  text.split('<br>').map((translation, index) =>
    index % 2 === 0 ? <h5 key={index}>{translation}</h5> : <p key={index}>{translation}</p>
  );

export const renderHowDoesUniplacesWorkText = text =>
  text.split('<br>').map((translation, index) => {
    if (index !== 1) {
      return renderElement(translation, index);
    }
    
    const orderedListRegex = /<ol>(.*)<\/ol>/g;

    return translation.split(orderedListRegex)
      .filter(Boolean)
      .map(
        (translation, index) => index === 0
          ? renderElement(translation, index)
          : renderElement(translation, index, 'ol')
      );
  });
